const creditFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function formatCredits(value: number) {
  if (!Number.isFinite(value)) {
    return '0';
  }

  return creditFormatter.format(value);
}

export function formatPlanName(planCode?: string | null) {
  if (!planCode) {
    return '';
  }

  switch (planCode.toLowerCase()) {
    case 'signup_bonus':
      return 'Signup Bonus';
    case 'trial':
      return 'Starter';
    case 'light':
    case 'value':
    case 'value_annual':
    case 'value_v2':
      return 'Value';
    case 'pro':
    case 'pro_v2':
      return 'Pro';
    case 'max':
    case 'max_v2':
      return 'Max';
    default:
      return planCode
        .replace(/_/g, ' ')
        .replace(/\b\w/g, match => match.toUpperCase());
  }
}
